import SignupInfoBuilder from '../common/SignupInfoBuilder';

class SubmitSignupService {
  constructor(rest) {
    this.rest = rest;
  }

  request(signupDetails, zuoraToken, paymentMethodId, plan, isContractSelected, withMobileDiscountInfo, isByoModemSelected) {
    const signupInfo = SignupInfoBuilder.build(
      signupDetails, zuoraToken, paymentMethodId, plan, isContractSelected, withMobileDiscountInfo, isByoModemSelected);
    return this.rest({
      method: 'POST',
      path: '/api/customer-self-management/rest/customerSelfManagement/customer/signup',
      entity: signupInfo
    })
    .then(response => response.entity);
  }
}

export default SubmitSignupService;



/** WEBPACK FOOTER **
 ** ./src/services/SubmitSignupService.js
 **/